import { useContext, useState } from 'react';
import { AppContext } from '../../context/AppContext';
import { MapContext } from '../../context/MapContext';
import './Tab.css';
import { householdLayers, poiLayers } from '../content/layer';
import { poiList } from '../../common/data/list';
import { Alert, Snackbar } from '@mui/material';

export default function Tab() {
	const { setDataSourceOpen } = useContext(AppContext);

	const {
		mode,
		setMode,
		setBgMap,
		setMap,
		sidoCd,
		setSidoCd,
		sggCd,
		setSggCd,
		setMinInput,
		setMaxInput,
		setSelectPoi,
		setSelectDistance,
		setSelectStandard,
		setPoiInfo,
		setGridOpacity,
		setPopupOpen,
		setPopupPosition,
		setPopupBind,
		setZoom,
	} = useContext(MapContext);

	const [snackBarOpen, setSnackBarOpen] = useState(false);

	const onClickRefresh = () => {
		window.location.reload();
	};

	const initializeMap = () => {
		setPopupOpen(false);
		setPopupPosition({ x: 0, y: 0 });
		setPopupBind({ x: 0, y: 0 });
		setBgMap('basic');
		setMap(null);
		setSidoCd('');
		setSggCd('');
		setMinInput(0.0);
		setMaxInput(19330.0);
		setSelectPoi('');
		setSelectDistance('');
		setSelectStandard('');
		setPoiInfo([]);
		setGridOpacity(1);
		setZoom();
		poiList.forEach((layer) => {
			layer.layerName.setVisible(false);
		});
		householdLayers.sphAgglomerateLayer.setVisible(false);
		householdLayers.sphLocationLayer.setVisible(false);
		poiLayers.industryPolygon.setVisible(false);
	};

	const handleIntroBtn = () => {
		setMode('intro');
		// initializeMap();
	};

	const handleAgglomerateBtn = () => {
		setMode('agglomerate');
		setPopupOpen(false);
	};

	const handleLocationBtn = () => {
		if (sidoCd !== '' || sggCd !== '') {
			setMode('location');
			setPopupOpen(false);
		} else {
			setSnackBarOpen(true);
		}
	};

	return (
		<div className="leftMenu">
			<img className="logoImg" src="img/KRIHS_logo.png" alt="KRIHS logo" />
			<div className="logoText">
				KRIHS
				<br />
				인터랙티브
				<br />
				리포트
				<br />
			</div>
			<button className="logoSubText" onClick={onClickRefresh}>
				1인가구 집적지
			</button>
			<div className="menulist">
				<button
					className={mode === 'intro' ? 'click' : null}
					onClick={handleIntroBtn}
				>
					<svg width="25" height="25" viewBox="0 0 32 32">
						<path d="M14.3203 3.25868C14.7954 2.87327 15.3886 2.66293 16.0003 2.66293C16.6121 2.66293 17.2052 2.87327 17.6803 3.25868L27.851 11.4987C28.3135 11.8732 28.6865 12.3462 28.943 12.8832C29.1995 13.4201 29.333 14.0076 29.3337 14.6027V26.6667C29.3337 27.3739 29.0527 28.0522 28.5526 28.5523C28.0525 29.0524 27.3742 29.3333 26.667 29.3333H22.667C21.9597 29.3333 21.2815 29.0524 20.7814 28.5523C20.2813 28.0522 20.0003 27.3739 20.0003 26.6667V20C20.0003 19.6464 19.8598 19.3073 19.6098 19.0572C19.3598 18.8072 19.0206 18.6667 18.667 18.6667H13.3337C12.98 18.6667 12.6409 18.8072 12.3908 19.0572C12.1408 19.3073 12.0003 19.6464 12.0003 20V26.6667C12.0003 27.3739 11.7194 28.0522 11.2193 28.5523C10.7192 29.0524 10.0409 29.3333 9.33366 29.3333H5.33366C4.62641 29.3333 3.94814 29.0524 3.44804 28.5523C2.94794 28.0522 2.66699 27.3739 2.66699 26.6667V14.6053C2.66687 14.0094 2.79994 13.4209 3.05647 12.8829C3.31299 12.3449 3.68649 11.8711 4.14966 11.496L14.3203 3.25868Z" />
					</svg>
					<span>리포트 소개</span>
				</button>
			</div>
			{snackBarOpen ? (
				<Snackbar
					className="alert"
					open={snackBarOpen}
					autoHideDuration={4000}
					onClose={() => setSnackBarOpen(false)}
				>
					<Alert
						onClose={() => setSnackBarOpen(false)}
						severity="info"
						sx={{ width: '100%' }}
					>
						<p className="snackbarContent">
							'Step 1. 집적지 분석'을 먼저 수행하세요!
						</p>
					</Alert>
				</Snackbar>
			) : null}
			<div className="menulist">
				<button
					className={mode === 'agglomerate' ? 'click' : null}
					onClick={handleAgglomerateBtn}
				>
					<svg width="25" height="25" viewBox="0 0 32 32">
						<path d="M12.4965 1.67816C12.9783 1.24154 13.6032 1 14.2509 1C14.8986 1 15.5234 1.24154 16.0053 1.67816L25.6303 10.4013C25.9039 10.6495 26.1228 10.953 26.2726 11.2921C26.4224 11.6311 26.4999 11.9982 26.5 12.3694V14.0568C25.8323 13.668 25.0878 13.4322 24.3196 13.3662C23.5513 13.3003 22.7781 13.4057 22.0548 13.6751C21.3316 13.9445 20.6759 14.3713 20.1346 14.925C19.5932 15.4788 19.1794 16.146 18.9225 16.8792H11.625C11.3929 16.8792 11.1704 16.9722 11.0063 17.1377C10.8422 17.3032 10.75 17.5277 10.75 17.7618V24.8221C10.75 25.5243 10.4734 26.1978 9.98116 26.6943C9.48887 27.1908 8.82119 27.4698 8.125 27.4698H4.625C3.92881 27.4698 3.26113 27.1908 2.76884 26.6943C2.27656 26.1978 2 25.5243 2 24.8221V12.3694C2 11.6192 2.315 10.9043 2.8715 10.4013L12.4965 1.67816ZM27.375 18.6443C27.375 19.5806 27.0063 20.4785 26.3499 21.1405C25.6935 21.8026 24.8033 22.1745 23.875 22.1745C22.9467 22.1745 22.0565 21.8026 21.4001 21.1405C20.7437 20.4785 20.375 19.5806 20.375 18.6443C20.375 17.708 20.7437 16.8101 21.4001 16.1481C22.0565 15.486 22.9467 15.1141 23.875 15.1141C24.8033 15.1141 25.6935 15.486 26.3499 16.1481C27.0063 16.8101 27.375 17.708 27.375 18.6443ZM30 26.5872C30 28.7848 28.25 31 23.875 31C19.5 31 17.75 28.7936 17.75 26.5872C17.75 25.885 18.0266 25.2116 18.5188 24.7151C19.0111 24.2185 19.6788 23.9396 20.375 23.9396H27.375C28.0712 23.9396 28.7389 24.2185 29.2312 24.7151C29.7234 25.2116 30 25.885 30 26.5872Z" />
					</svg>
					<span>Step 1.<br />집적지 분석</span>
				</button>
			</div>
			<div className="menulist">
				<button
					className={mode === 'location' ? 'click' : null}
					onClick={handleLocationBtn}
				>
					<svg width="25" height="25" viewBox="0 0 32 32">
						<path d="M4 5C4 4.20435 4.31607 3.44129 4.87868 2.87868C5.44129 2.31607 6.20435 2 7 2H18.75C19.1768 2 19.5994 2.08406 19.9937 2.24739C20.388 2.41072 20.7463 2.65011 21.0481 2.9519C21.3499 3.25369 21.5893 3.61197 21.7526 4.00628C21.9159 4.40059 22 4.8232 22 5.25V13H24.75C25.1768 13 25.5994 13.0841 25.9937 13.2474C26.388 13.4107 26.7463 13.6501 27.0481 13.9519C27.3499 14.2537 27.5893 14.612 27.7526 15.0063C27.9159 15.4006 28 15.8232 28 16.25V29C28 29.2652 27.8946 29.5196 27.7071 29.7071C27.5196 29.8946 27.2652 30 27 30H23V25.5C23 25.1022 22.842 24.7206 22.5607 24.4393C22.2794 24.158 21.8978 24 21.5 24H10.5C10.1022 24 9.72064 24.158 9.43934 24.4393C9.15804 24.7206 9 25.1022 9 25.5V30H5C4.73478 30 4.48043 29.8946 4.29289 29.7071C4.10536 29.5196 4 29.2652 4 29V5ZM21 26V30H17V26H21ZM15 26V30H11V26H15ZM12 8.5C12 8.10218 11.842 7.72064 11.5607 7.43934C11.2794 7.15804 10.8978 7 10.5 7C10.1022 7 9.72064 7.15804 9.43934 7.43934C9.15804 7.72064 9 8.10218 9 8.5C9 8.89782 9.15804 9.27936 9.43934 9.56066C9.72064 9.84196 10.1022 10 10.5 10C10.8978 10 11.2794 9.84196 11.5607 9.56066C11.842 9.27936 12 8.89782 12 8.5ZM12 13.5C12 13.1022 11.842 12.7206 11.5607 12.4393C11.2794 12.158 10.8978 12 10.5 12C10.1022 12 9.72064 12.158 9.43934 12.4393C9.15804 12.7206 9 13.1022 9 13.5C9 13.8978 9.15804 14.2794 9.43934 14.5607C9.72064 14.842 10.1022 15 10.5 15C10.8978 15 11.2794 14.842 11.5607 14.5607C11.842 14.2794 12 13.8978 12 13.5ZM10.5 20C10.8978 20 11.2794 19.842 11.5607 19.5607C11.842 19.2794 12 18.8978 12 18.5C12 18.1022 11.842 17.7206 11.5607 17.4393C11.2794 17.158 10.8978 17 10.5 17C10.1022 17 9.72064 17.158 9.43934 17.4393C9.15804 17.7206 9 18.1022 9 18.5C9 18.8978 9.15804 19.2794 9.43934 19.5607C9.72064 19.842 10.1022 20 10.5 20ZM17 8.5C17 8.10218 16.842 7.72064 16.5607 7.43934C16.2794 7.15804 15.8978 7 15.5 7C15.1022 7 14.7206 7.15804 14.4393 7.43934C14.158 7.72064 14 8.10218 14 8.5C14 8.89782 14.158 9.27936 14.4393 9.56066C14.7206 9.84196 15.1022 10 15.5 10C15.8978 10 16.2794 9.84196 16.5607 9.56066C16.842 9.27936 17 8.89782 17 8.5ZM15.5 15C15.8978 15 16.2794 14.842 16.5607 14.5607C16.842 14.2794 17 13.8978 17 13.5C17 13.1022 16.842 12.7206 16.5607 12.4393C16.2794 12.158 15.8978 12 15.5 12C15.1022 12 14.7206 12.158 14.4393 12.4393C14.158 12.7206 14 13.1022 14 13.5C14 13.8978 14.158 14.2794 14.4393 14.5607C14.7206 14.842 15.1022 15 15.5 15ZM17 18.5C17 18.1022 16.842 17.7206 16.5607 17.4393C16.2794 17.158 15.8978 17 15.5 17C15.1022 17 14.7206 17.158 14.4393 17.4393C14.158 17.7206 14 18.1022 14 18.5C14 18.8978 14.158 19.2794 14.4393 19.5607C14.7206 19.842 15.1022 20 15.5 20C15.8978 20 16.2794 19.842 16.5607 19.5607C16.842 19.2794 17 18.8978 17 18.5ZM20.5 20C20.8978 20 21.2794 19.842 21.5607 19.5607C21.842 19.2794 22 18.8978 22 18.5C22 18.1022 21.842 17.7206 21.5607 17.4393C21.2794 17.158 20.8978 17 20.5 17C20.1022 17 19.7206 17.158 19.4393 17.4393C19.158 17.7206 19 18.1022 19 18.5C19 18.8978 19.158 19.2794 19.4393 19.5607C19.7206 19.842 20.1022 20 20.5 20Z" />
					</svg>
					<span>Step 2.<br />입지속성 분석</span>
				</button>
			</div>
			<div className="copyright" onClick={() => setDataSourceOpen(true)}>
				<div>
					<img src="img/iconQuest.png" alt="데이터 출처, 유의사항 보기" />
				</div>
				<span>
					데이터 출처, <br />
					유의사항 보기
				</span>
			</div>
		</div>
	);
}
